<app-safetypoint-suche (safetypointSelected)="handleSafetypointSelected($event)"></app-safetypoint-suche>